import { selectorForSlice, setState } from 'lp-redux-utils';
import { handleActions } from 'redux-actions';
import * as actions from './globalActions';
const reducerKey = 'global';
const slice = 'root.global';
const initialState = {};
const reducer = handleActions({
    [actions.recordApplicationBuildId.toString()]: setState('applicationBuildId'),
    [actions.setReactiveSessionStorage.toString()]: setState('reactiveSessionStorage'),
}, initialState);
const select = selectorForSlice(slice);
const selectors = {
    applicationBuildId: select('applicationBuildId'),
    reactiveSessionStorage: select('reactiveSessionStorage'),
};
export { reducer, selectors, reducerKey };
